export default __webpack_public_path__ + "static/media/ic-more-black.4de3e2bb.svg";